import { type StateCode, states } from "@plasma/data/states";

export interface Address {
  addressLine1: string;
  addressLine2: string | null;
  city: string;
  state: StateCode;
  zipCode: string | number;
}

function getAddressField(obj: object, key: keyof Address): unknown {
  return Reflect.get(obj, key);
}

// Helper to check if an object has all required address fields
export const hasRequiredAddressFields = (obj: unknown): obj is Address => {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  const addressLine1 = getAddressField(obj, "addressLine1");
  const city = getAddressField(obj, "city");
  const state = getAddressField(obj, "state");
  const zipCode = getAddressField(obj, "zipCode");
  return !!(
    addressLine1 &&
    typeof addressLine1 === "string" &&
    city &&
    typeof city === "string" &&
    state &&
    typeof state === "string" &&
    zipCode !== null &&
    zipCode !== undefined
  );
};

export const formatAddress = (address: Address) =>
  `${address.addressLine1}${address.addressLine2 ? ` ${address.addressLine2}` : ""}, ${address.city}, ${states[address.state]}, ${address.zipCode.toString()}`;

export const formatAddressMultiline = (address: Address): string[] => {
  const lines: string[] = [address.addressLine1];
  if (address.addressLine2) {
    lines.push(address.addressLine2);
  }
  lines.push(
    `${address.city}, ${address.state.toUpperCase()}`,
    address.zipCode.toString()
  );
  return lines;
};
